// src/pages/EventList.tsx

import React from 'react';
import EventCard from './EventCard';
import { Event } from './types';

interface EventListProps {
  events: Event[];
}

const EventList: React.FC<EventListProps> = ({ events }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {events.map(event => (
        <EventCard
          key={event.id}
          id={event.id}
          imageUrl={`${process.env.REACT_APP_API_BASE_URL}${event.imageUrl}`}
          title={event.title}
          startDate={event.startDate}
          rewardStartDate={event.rewardStartDate} // 추가
          rewardEndDate={event.rewardEndDate}
          endDate={event.endDate}
          isNew={event.isNew}
        />
      ))}
    </div>
  );
};

export default EventList;
